import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { Router, NavigationStart, NavigationCancel, NavigationEnd } from '@angular/router';
import { ProgressEventHandler } from 'src/app/shared/models/progress/progressEventHandler';

@Injectable({
  providedIn: 'root'
})
export class ProgressService {
  protected _isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public readonly isLoading: Observable<boolean> = this._isLoading.asObservable();
  protected _percentageEventsComplete: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public readonly percentageEventsComplete: Observable<number> =
    this._percentageEventsComplete.asObservable();

  public progressEventHandler: ProgressEventHandler = new ProgressEventHandler();
  private readonly navigationEvent: string = 'navigation';

  get totalEventLength(): number {
    return this.progressEventHandler.totalEventLength;
  }

  get completedEventLength(): number {
    return this.progressEventHandler.completedEventLength;
  }

  constructor(private router: Router) {
    let service = this;

    service.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        service.navigationStart();
      } else if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
        service.navigationEnd();
      }
    });
  }

  startLoading(eventName): void {
    let service = this;
    if (eventName) {
      service.progressEventHandler.addNewEvent(eventName);
      service.updatePercentageEventsComplete();
    }
    if (!service._isLoading.value) {
      service._isLoading.next(true);
    }
  }

  stopLoading(eventName): void {
    let service = this;
    service.progressEventHandler.resolveEvent(eventName);
    service.updatePercentageEventsComplete();

    if (service.progressEventHandler.allEventsAreResolved()) {
      service.progressEventHandler.clearEvents(service.finishLoadingReference());
    }
  }

  updatePercentageEventsComplete() {
    let service = this;
    let value = (service.completedEventLength / service.totalEventLength) * 100;
    service._percentageEventsComplete.next(value);
  }

  navigationStart() {
    let service = this;
    service.startLoading(service.navigationEvent);
  }

  navigationEnd() {
    let service = this;
    service.stopLoading(service.navigationEvent);
  }

  finishLoading = () => {
    this._isLoading.next(false);
  };

  finishLoadingReference() {
    let service = this;
    return function () {
      service.finishLoading();
    };
  }
}
